import { WidgetProps } from '@rjsf/utils';
import { KnownUploadImageDtoCategory } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Grid, Typography } from '@mui/material';
import { ImageUpload } from '../../../../ui/components/higher-order/image-upload/image-upload.component';

function filenameFromUrl(url: string): string {
  try {
    const pathname = new URL(url).pathname;
    const part = pathname.split('/').pop() ?? '';
    return decodeURIComponent(part);
  } catch {
    return url.split('/').pop() ?? url;
  }
}

export function DynamicFormImageUpload(props: WidgetProps) {
  const { onChange, id, options } = props;

  return (
    <Grid
      container
      spacing={2}
      wrap="nowrap"
      sx={{
        alignItems: 'center'
      }}
    >
      <Grid>
        <ImageUpload
          id={id}
          isPublic={options?.isPublic as boolean | undefined}
          category={options?.category as KnownUploadImageDtoCategory | undefined}
          onUploaded={onChange}
          disabled={props.readonly}
          value={props.value}
          showPreview={options?.showPreview as boolean | undefined}
        >
          {options?.buttonLabel as string | undefined}
        </ImageUpload>
      </Grid>
      {props.value && (
        <Grid>
          <Typography variant="body2">
            <a href={props.value} target="_blank" rel="noopener noreferrer" style={{ color: '#666' }}>
              {filenameFromUrl(props.value)}
            </a>
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
